import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ClientSignIn from "./Pages/Registration/ClientSignIn";
import ClientSignup from "./Pages/Registration/ClientSignup";
import WelcomePage from "./Pages/welcomePage/WelcomePage";
import ProtectedRoutes from "./Routes/DashboardRoute";
import "./App.css";
import ClientContextProvider from "./Context_file/ClientContext";

const App = () => {
  return (
    <div className="App">
      <Router>
        <ClientContextProvider>
          <Switch>
            <Route path="/" component={ClientSignIn} exact />
            <Route path="/login" component={ClientSignIn} exact />
            <Route path="/register" component={ClientSignup} exact />
            <ProtectedRoutes path="/channel" component={WelcomePage} exact />
          </Switch>
        </ClientContextProvider>
      </Router>
    </div>
  );
};

export default App;
